import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import {
  apiActionResult,
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import getCountConfig from './getCount';
import { default as setTaskSuccess } from './setTaskSuccess';

const actions = createActions({
  TASK: {
    ASSIGN_TASK: (task, user) => ({ task, user }),
    API: {
      ASSIGN_TASK: apiResourceActionCreator('task')
    }
  }
});

export const apiAction = (authToken, formData) =>
  commonApiActions.authenticated.postFormData(
    `${API_ENDPOINT}/assign`,
    authToken,
    formData,
    actions.task.api.assignTask
  );

/**
 * Saga worker that formats the task payload, maps file attachments,
 * executes the API request, and updates global task counters upon success.
 */
function* assignTask(action) {
  const authToken = yield select(authTokenSelector);

  const {
    task: {
      name,
      description,
      dueDate,
      isArchived,
      contents,
      courses,
      users,
      cpdCategorys,
      links,
      files
    },
    user
  } = action.payload;

  const tasks = [
    {
      name,
      description,
      dueDate,
      isArchived,
      userId: user.id
    }
  ];

  const taskTransport = {
    tasks,
    cpdCategorys,
    contents,
    courses,
    links,
    users
  };

  const formData = {
    data: taskTransport,
    file: fp.filter((file) => file)(files)
  };
  yield put(apiAction(authToken, formData));
  const result = yield apiActionResult(actions.task.api.assignTask);

  if (result.success) {
    yield put(getCountConfig.action.task.getCount());
    yield put(push({ pathname: routes.app.tasks.home }));

    yield put(
      setTaskSuccess.action.task.setTaskSuccess({
        success: true,
        info: `Successfully created task [${name}].`
      })
    );
  } else {
    yield put(
      setTaskSuccess.action.task.setTaskSuccess({
        success: false,
        info: `Failed to create task [${name}]`
      })
    );
  }
}

/**
 * Redux configuration bundle mapping actions, sagas, and slice state reducers
 * for assigning new compliance tasks to system users.
 */
const configuration = {
  name: 'assignTask',
  action: actions,
  sagas: assignTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isAssigningTask: true
    }),
    success: (state, action) => {
      const taskIds =
        action.payload && action.payload.task && action.payload.task.taskIds;
      return {
        ...state,
        isAssigningTask: false,
        activeTrackingTaskIds: Array.isArray(taskIds) ? taskIds : []
      };
    },
    failed: (state, action) => ({
      ...state,
      isAssigningTask: false
    })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/assignTask.js